module.exports = __webpack_public_path__ + "media/images/ic-map-circle-hover-f3e75276.svg";